<template>
  <div class="contact-item">
    <slot name="icon"></slot>
    <div class="contact-item__info">
      <div class="title">{{ title }}</div>
      <div class="value">{{ value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactItem",
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.contact-item {
  display: flex;
  align-items: center;
}

.contact-item__info {
  flex: 1;
  margin-left: 32px;
}

.title {
  color: #50627f;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 8px;
}

.value {
  color: #1f2329;
  font-size: 24px;
  font-weight: 500;
}

@media screen and (max-width: 1000px) {
  .contact-item {
    align-items: flex-start !important;
  }

  .title {
    line-height: 20px;
    font-size: 14px;
  }

  .contact-item__info {
    flex: 1;
    margin-left: 8px;
  }

  svg {
    width: 20px;
    height: 20px;
  }

  .value {
    font-size: 18px;
  }
}
</style>>